import { Pressable } from '@cbhq/cds-web/system';
import { ANALYTICS_KEY } from '../../constants.js';
import { AnalyticsProvider } from '../../providers/AnalyticsProvider.js';
import '../Div/index.js';
import { LinkPressable } from '../Link/LinkPressable.js';
import { Text } from '../Text.js';
import { jsx } from 'react/jsx-runtime';
import { Div } from '../Div/Div.js';
function PillTags({
  tags
}) {
  return /*#__PURE__*/jsx(Div, {
    flexWrap: "wrap",
    children: tags?.map(({
      label,
      url,
      onClick
    }, index) => /*#__PURE__*/jsx(Div, {
      spacingEnd: 1,
      spacingBottom: 1,
      children: /*#__PURE__*/jsx(AnalyticsProvider, {
        analyticsPrefix: `${ANALYTICS_KEY.PillTag}${index}`,
        children: onClick ? /*#__PURE__*/jsx(Pressable, {
          background: "transparent"
          // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
          ,

          onPress: () => onClick({
            label
          }),
          children: /*#__PURE__*/jsx(PillTag, {
            label: label
          })
        }) : url ? /*#__PURE__*/jsx(LinkPressable, {
          href: url,
          children: /*#__PURE__*/jsx(PillTag, {
            label: label
          })
        }) : /*#__PURE__*/jsx(PillTag, {
          label: label
        })
      })
    }, index))
  });
}
function PillTag({
  label
}) {
  return /*#__PURE__*/jsx(Div, {
    background: "primaryWash",
    borderRadius: "roundedLarge",
    children: /*#__PURE__*/jsx(Text, {
      color: "foreground",
      variant: "label1",
      spacingVertical: 1,
      spacingHorizontal: 4,
      as: "p",
      children: label
    })
  });
}
export { PillTags };
//# sourceMappingURL=PillTags.js.map
